/* eslint-disable jsx-a11y/aria-proptypes */
import { Label } from '@progress/kendo-react-labels'
import parse from 'html-react-parser'
import { useEffect } from 'react'
import { SurveyEngine_Models_BaseResponse, SurveyService_Models_AnnounceResponse } from '../../../api'


interface AnnounceProps {
  id: number
  message: string
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const Announce = (props: AnnounceProps) => {
  const sanitizedMsg = props.message?.replaceAll(/""/g, '"')
  useEffect(() => {
    let response: SurveyService_Models_AnnounceResponse = {
      commandType: "Announce",
      commandIndex: props.id,
    }
    props.callback(response);
  });
  return (
    <>
      <div className="theme-announce w-full" data-testid="announce" autoFocus>
        <Label id={`Announce_${props.id}`} aria-live className="py-10 text-xl font-semibold">
          {' '}
          {parse(sanitizedMsg)}
        </Label>
      </div>
    </>
  )
}
export default Announce


